// extracted by mini-css-extract-plugin
export default {"root":"ChatMessages_root__q52ff","date":"ChatMessages_date__DrZog"};